import type { ReactNode } from 'react';

export const symbol_troubleshoot: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M430-260q-57 0-108.5-19.5T229-334q-10-8-11-21t8-23q8-9 21-8.5t23 8.5q32 27 73.5 42.5T430-320q104 0 177-73.5T680-570q0-104-73-177t-177-73q-92 0-161 58.5T184-615q-2 14-11 24.5T150-580q-14 0-21-12t-5-27q17-111 103-186t203-75q129 0 219.5 90.5T740-570q0 54-19.5 105.5T669-373l190 190q9 9 9 21t-9 21q-9 9-21 9t-21-9L627-331q-40 32-91.5 51.5T430-260Zm-3-246 37-115q3-8 9.5-13.5T489-640h24q8 0 14 4t10 11l53 105q13 0 21.5 8.5T620-490q0 13-8.5 21.5T590-460h-18q-8 0-15.5-4.5T545-477l-39-77-44 135q-3 9-10 14t-16 5h-18q-9 0-16.5-5.5T391-420l-57-188-45 128q-3 9-10.5 14.5T261-460H110q-13 0-21.5-8.5T80-490q0-13 8.5-21.5T110-520h130l59-171q3-9 10.5-14t16.5-5h19q10 0 17 6t10 15l55 183Z"
		/>
	</svg>
);
